// src\Pages\Home\TrendFashion\index.tsx
import React from "react";
import PageRenderer from "./PageRenderer";

const TrendFashion = () => {
  document.title = "FionaZiya";

  return (
    <React.Fragment>
      <PageRenderer pageSlug="home" />
    </React.Fragment>
  );
};

export default TrendFashion;